import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PreviewModal = ({ isOpen, onClose, content, metadata }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="max-h-[90vh] w-full max-w-4xl overflow-hidden rounded-lg bg-card shadow-card">
        <div className="flex items-center justify-between border-b border-border p-4">
          <div>
            <h2 className="text-lg font-semibold text-foreground">미리보기</h2>
            <p className="mt-1 text-sm text-muted-foreground">
              고객에게 표시되는 방식으로 약관을 확인하세요
            </p>
          </div>
          <button
            onClick={onClose}
            className="rounded-md p-2 text-foreground transition-colors duration-150 ease-out hover:bg-muted"
            aria-label="닫기"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="max-h-[calc(90vh-120px)] overflow-y-auto p-6">
          <div className="mx-auto max-w-3xl">
            <div className="mb-6 border-b border-border pb-4">
              <h1 className="text-2xl font-bold text-foreground">{metadata?.title}</h1>
              <div className="mt-2 flex flex-wrap gap-4 text-sm text-muted-foreground">
                <span>버전 {metadata?.version}</span>
                <span>시행일: {new Date(metadata.effectiveDate)?.toLocaleDateString('ko-KR')}</span>
              </div>
            </div>

            <div className="prose prose-sm max-w-none">
              <div className="whitespace-pre-wrap text-foreground">{content}</div>
            </div>
          </div>
        </div>

        <div className="border-t border-border p-4">
          <div className="flex justify-end">
            <Button variant="outline" onClick={onClose}>
              닫기
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewModal;